// Assets
import heroImage from '../../assets/img/hero/cacio-e-pepe-hero.jpg';
import thumbnail from '../../assets/img/recipes/cacio-e-pepe-thumb.jpg';

export default {
  hasTransparentNav: false,
  hasRebateCallout: true,
  metadata: {
    title: 'Cacio e Pepe by Chef Kurt Fleischfresser',
    description:
      'Chef Kurt Fleischfresser makes two versions of incredibly juicy Cacio e Pepe. Whether you dig into his recipe for seared Cacio e Pepe with country potatoes or his roasted double Cacio e Pepe with garlic and pine nuts, his two methods are the best of the best.',
    type: 'video.episode'
  },
  active: true,
  title: 'Cacio e Pepe',
  hero: {
    image: heroImage,
    video: '',
    title: '',
    cta: '',
    link: ''
  },
  episode: 'S1:E3',
  episodeLong: 'Season One Episode Three',
  className: 'episode-detail',
  thumbnail,
  content:
    'Put your pan-searing skills to practice with either of Chef Kurt Fleischfresser’s incredibly juicy Cacio e Pepe. Whether you dig into his recipe for seared Cacio e Pepe with country potatoes or his roasted double Cacio e Pepe with garlic and pine nuts, his two methods are the best of the best.',
  excerpt:
    'Chef Jonathon Stranger has perfected this staple of Italian cooking. It’s like mac and cheese if macaroni could go to college.',
  videoIds: ['_dAK2uk4yfg'],
  playlistId: 'PL6bvPOjDXPzijS0wUPlVnGauAG99P2Ojn',
  url: '/episodes/cacio-e-pepe',
  recipe: 'cacioEPepe',
  chef: 'kurtFleischfresser',
  season: 1
};
